import React from "react";
import { Route, Switch } from "react-router-dom";

import { Admins } from "constants/userRoles";
import { PHONE_NUMBER, SIM_CARD } from "constants/routes";

import PhoneNumberIndex from "views/PhoneNumber/PhoneNumberIndex";
import PhoneNumberCreate from "views/PhoneNumber/PhoneNumberCreate";
import PhoneNumberDetail from "views/PhoneNumber/PhoneNumberDetail";
import PhoneNumberEdit from "views/PhoneNumber/PhoneNumberEdit";
import SimCardIndex from "views/SimCard/SimCardIndex";
import SimCardDetail from "views/SimCard/SimCardDetail";
import AssignSimCard from "views/SimCard/AssignSimCard";
import SimCardEdit from "views/SimCard/SimCardEdit";

const TelecomRoutes = () => (
  <Switch>
    <Route
      exact
      path={PHONE_NUMBER.INDEX}
      component={Admins(PhoneNumberIndex)}
    />
    <Route path={PHONE_NUMBER.CREATE} component={Admins(PhoneNumberCreate)} />
    <Route
      path={PHONE_NUMBER.SHOW}
      component={Admins(PhoneNumberDetail)}
      exact
    />
    <Route path={PHONE_NUMBER.EDIT} component={Admins(PhoneNumberEdit)} exact />
    <Route path={SIM_CARD.INDEX} component={Admins(SimCardIndex)} exact />
    <Route path={SIM_CARD.SHOW} component={Admins(SimCardDetail)} exact />
    <Route path={SIM_CARD.ASSIGN} component={Admins(AssignSimCard)} />
    <Route path={SIM_CARD.EDIT} component={Admins(SimCardEdit)} />
  </Switch>
);

export default TelecomRoutes;
